import Moment from 'moment';
import { get } from '..';

interface GetTicketStatsParams {
  buildingId: string;
  from?: string;
  to?: string;
  templateId?: string;
  templateGroupId?: string;
}

const getTicketStats = ({
  buildingId,
  from = Moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
  to = Moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
  templateId,
  templateGroupId,
}: GetTicketStatsParams) => {
  let url: string = `metrics/ticket/statistics?buildingId=${buildingId}`;
  if (from) url += `&from=${from}`;
  if (to) url += `&to=${to}`;
  if (templateId) {
    url += `&templateId=${templateId}`;
  } else if (templateGroupId) {
    url += `&templateGroupId=${templateGroupId}`;
  }
  return get(url);
};

export default getTicketStats;
